import type { MessageKey } from "./ru"

export const frMessages = {
  "common.loading": "Chargement...",
  "common.error": "Erreur",
  "common.back": "Retour",
  "common.next": "Suivant",
  "common.search": "Rechercher",
  "auth.loginErrorTitle": "Erreur de connexion",
  "auth.openViaTelegram": "Ouvrez l’application via Telegram",
  "auth.telegramRequired": "L’application doit être ouverte via Telegram",
  "auth.authorizationError": "Erreur d’autorisation",
  "device.rotatePortrait": "Tournez votre appareil en mode portrait",
  "country.brazil": "Brésil",
  "country.vietnam": "Vietnam",
  "country.egypt": "Égypte",
  "country.india": "Inde",
  "country.indonesia": "Indonésie",
  "country.iran": "Iran",
  "country.spain": "Espagne",
  "country.italy": "Italie",
  "country.kazakhstan": "Kazakhstan",
  "country.colombia": "Colombie",
  "country.malaysia": "Malaisie",
  "country.mexico": "Mexique",
  "country.nigeria": "Nigeria",
  "country.pakistan": "Pakistan",
  "country.russia": "Russie",
  "country.usa": "États-Unis",
  "country.turkey": "Turquie",
  "country.uzbekistan": "Ouzbékistan",
  "country.ukraine": "Ukraine",
  "country.philippines": "Philippines",
  "countrySelection.chooseCountry": "Choisissez un pays",
  "countrySelection.openAria": "Choisissez un pays",
  "languageSelection.chooseLanguage": "Choisissez une langue",
  "commercial.direction.autotrade": "Marché auto",
  "commercial.direction.insurance": "Assurance",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Assistance routière",
  "commercial.searchLabel": "Recherche BeepApp",
  "commercial.cityPlaceholder": "Saisissez une ville",
  "commercial.emptyTitle": "Aucune offre aujourd’hui",
  "commercial.emptyLine1": "Il n’y a pas encore de partenaires BeepApp actifs dans votre ville",
  "commercial.emptyLine2": "Nous travaillons déjà à en trouver et à les connecter",
  "commercial.emptyLine3": "Les nouvelles offres apparaîtront ici automatiquement",
  "commercial.helperLine1": "Saisissez votre ville pour voir",
  "commercial.helperLine2": "les offres disponibles",
  "commercial.partnerPrompt": "Vous souhaitez devenir partenaire BeepApp ?",
  "commercial.apply": "Postuler",
  "main.admin": "Admin",
  "main.garage": "Garage",
  "main.signalSent": "Signal envoyé",
  "main.partnerInviteUnavailable": "Invitation partenaire indisponible",
  "main.enterPlate": "Saisissez la plaque d’immatriculation",
  "main.searchError": "Erreur de recherche",
  "main.signalSendError": "Impossible d’envoyer le signal",
  "main.shareCardPrefix": "Fiche de plaque",
  "main.shareLinkError": "Impossible de préparer le lien",
  "main.searchByPlateAria": "Rechercher par plaque d’immatriculation",
  "main.russianPlateAria": "Plaque d’immatriculation russe",
  "main.plateAria": "Plaque d’immatriculation",
  "main.findPlateAria": "Trouver la plaque",
  "main.loadingVehicle": "Chargement de la fiche du véhicule…",
  "main.leaveSignal": "Envoyer un signal",
  "main.share": "Partager",
  "signalSelection.chooseType": "Choisissez le type de signal",
  "signalSelection.category.attention": "Personnel",
  "signalSelection.category.road": "Route",
  "signalSelection.category.urgent": "Urgent",
  "signalSelection.chooseSignal": "Choisissez un signal",
  "signalSelection.suggestOwn": "Proposer votre variante",
  "signalConfirmation.title": "Confirmer le signal",
  "signalConfirmation.plateHeading": "Vérifiez la plaque d’immatriculation",
  "signalConfirmation.signalHeading": "Vérifiez le signal sélectionné",
  "signalConfirmation.replyTitle": "Autoriser une réponse dans Telegram",
  "signalConfirmation.replyBody": "Activez cette option pour que le propriétaire de la plaque puisse\nvous écrire dans Telegram. Les réponses ne sont possibles que si\nvous avez un @username. La décision de répondre appartient\nau propriétaire de la plaque.",
  "signalConfirmation.consentText": "Je confirme que ce signal correspond\nà une situation réelle et qu’il ne s’agit ni de spam\nni d’un faux signalement.",
  "signalConfirmation.warning": "Après l’envoi, le signal\nne pourra plus être modifié",
  "signalConfirmation.sending": "Envoi…",
  "signalConfirmation.send": "Envoyer",
  "partner.loadingAria": "Chargement",
  "partner.title": "Programme partenaire",
  "partner.offerLine1": "Gagnez 30 % sur tous les paiements sans limite de durée",
  "partner.offerLine2": "effectués par les utilisateurs que vous invitez sur BeepApp",
  "partner.offerLine3": "via le programme d’affiliation Telegram",
  "partner.connectUnavailable": "La connexion sera disponible après la configuration du programme d’affiliation Telegram.",
  "partner.connectTelegram": "Connecter dans Telegram",
  "partner.qrAria": "Code QR du lien partenaire",
  "partner.download": "Télécharger",
  "partner.promoHeading": "Créer un code promo personnel",
  "partner.promoHelperLine1": "Le code promo active une année d’abonnement supplémentaire",
  "partner.promoHelperLine2": "et aide à attirer des utilisateurs",
  "partner.promoAria": "Code promo",
  "partner.affiliateHeading": "Votre lien partenaire",
  "partner.affiliateHelper": "Enregistrez le lien pour créer un code QR personnel",
  "partner.affiliateAria": "Lien partenaire",
  "partner.qrNoteLine1": "Le code QR peut être placé sur votre véhicule,",
  "partner.qrNoteLine2": "sur les réseaux sociaux et dans les supports publicitaires",
  "partner.save": "Enregistrer",
  "partner.reset": "Réinitialiser",
  "partner.resetConfirm": "Réinitialiser le lien partenaire enregistré ? Le code promo restera le vôtre.",
  "partner.promoFormatError": "Le code promo doit contenir de 4 à 15 caractères.",
  "partner.affiliateHostError": "Seuls les liens t.me ou telegram.me sont autorisés.",
  "partner.affiliatePathError": "Le lien ne contient pas de chemin Telegram.",
  "partner.affiliateFormatError": "Lien partenaire non valide.",
  "partner.loadError": "Erreur de chargement",
  "partner.checkInputError": "Vérifiez les informations saisies",
  "garageActivation.promoInvalid": "Le code promo n’est pas valide",
  "garageActivation.plateOccupied": "Cette plaque est déjà liée",
  "garageActivation.activateError": "Impossible d’activer le Garage",
  "garageEntry.loadJournalError": "Impossible de charger le journal de bord",
  "garageEntry.loadStatusesError": "Impossible de charger les statuts",
  "garageEntry.activationSuccess": "Garage activé avec succès",
  "garageEntry.plateAttached": "Plaque liée",
  "garageEntry.attachError": "Impossible de lier la plaque",
  "garageEntry.activationNote": "Activez votre Garage",
  "garageSheet.activationTitle": "Activation du Garage",
  "garageSheet.plateHelper": "Saisissez la plaque du véhicule",
  "garageSheet.promoHelper": "Avez-vous un code promo ?",
  "garageSheet.cleanBonusLine1": "Après l’activation, vous aurez 1 heure",
  "garageSheet.cleanBonusLine2": "pour un « Clean Start » gratuit",
  "garageSheet.activationFor": "Activation pour",
  "garageSheet.cost": "Coût",
  "garageSheet.ownerConsentLine1": "Je confirme être le propriétaire",
  "garageSheet.ownerConsentLine2": "du véhicule portant la plaque",
  "garageSheet.ownerConsentLine3": "indiquée.",
  "garageSheet.processing": "Traitement...",
  "garageSheet.attach": "Lier",
  "garageSheet.pay": "Payer",
  "garageLifecycle.cleanTitle": "Clean Start",
  "garageLifecycle.deactivateTitle": "Désactivation du Garage",
  "garageLifecycle.cleanWarningLine1": "L’historique de la plaque sera supprimé",
  "garageLifecycle.cleanWarningLine2": "sans possibilité de récupération !",
  "garageLifecycle.deactivateWarningLine1": "Après la désactivation, l’accès aux fonctions",
  "garageLifecycle.deactivateWarningLine2": "actives du Garage prendra fin",
  "garageLifecycle.willBeDeleted": "SERA SUPPRIMÉ",
  "garageLifecycle.cleanRemovedLine1": "• Toutes les entrées du journal de bord",
  "garageLifecycle.cleanRemovedLine2": "• Historique des signaux reçus",
  "garageLifecycle.cleanRemovedLine3": "• Compteurs publics de signaux",
  "garageLifecycle.cleanRemovedLine4": "  sur la fiche de la plaque",
  "garageLifecycle.willRemain": "SERA CONSERVÉ",
  "garageLifecycle.cleanPreservedLine1": "• Liaison de la plaque au Garage",
  "garageLifecycle.cleanPreservedLine2": "• Période d’activation restante",
  "garageLifecycle.cleanPreservedLine3": "• Statut de plaque sélectionné",
  "garageLifecycle.cleanPreservedLine4": "• Nombre total de vues de la fiche",
  "garageLifecycle.freeFirstHour": "Gratuit pendant la première heure",
  "garageLifecycle.willBecomeUnavailable": "DEVIENDRA INDISPONIBLE",
  "garageLifecycle.deactivateRemovedLine1": "• Journal de bord",
  "garageLifecycle.deactivateRemovedLine2": "• Sélection et utilisation du statut de plaque",
  "garageLifecycle.deactivateRemovedLine3": "• Vous quitterez automatiquement AutoClan",
  "garageLifecycle.deactivateRemovedLine4": "• Marché auto",
  "garageLifecycle.deactivateRemovedLine5": "• Assurance",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Assistance routière",
  "garageLifecycle.deactivateRemovedLine8": "• La plaque sera dissociée du Garage",
  "garageLifecycle.willRemainAvailable": "RESTERA DISPONIBLE",
  "garageLifecycle.deactivatePreservedLine1": "• Compagnon",
  "garageLifecycle.deactivatePreservedLine2": "• Dispatcher",
  "garageLifecycle.deactivatePreservedLine3": "• Recherche et consultation de plaque",
  "garageLifecycle.deactivatePreservedLine4": "  de la fiche publique du véhicule",
  "garageLifecycle.deactivatePreservedLine5": "• Possibilité de réactiver",
  "garageLifecycle.deactivatePreservedLine6": "  le Garage à tout moment",
  "garageLifecycle.cleanConsentLine1": "Je confirme mon accord pour supprimer",
  "garageLifecycle.cleanConsentLine2": "tout l’historique de cette plaque",
  "garageLifecycle.cleanConsentLine3": "sans possibilité de récupération.",
  "garageLifecycle.deactivateConsentLine1": "Je confirme la désactivation et",
  "garageLifecycle.deactivateConsentLine2": "la fin de l’accès à toutes les",
  "garageLifecycle.deactivateConsentLine3": "fonctions actives du Garage.",
  "garageLifecycle.clean": "Effacer",
  "garageLifecycle.deactivate": "Désactiver",
} satisfies Record<MessageKey, string>
